<p-toast />

<section class="w-full md:p-3">
  <app-content-card title="Muelle">
    <p class="m-0 mb-3 text-sm text-color-secondary">{{ subtitulo() }}</p>

    @if (aviso()) {
      <div
        class="flex align-items-start gap-2 mb-3 px-3 py-2 border-round surface-100 text-sm"
        role="status"
      >
        <i class="pi pi-exclamation-triangle mt-1" aria-hidden="true"></i>
        <span>{{ aviso() }}</span>
      </div>
    }

    @if (mostrarTabla()) {
      <div class="border-1 surface-border border-round overflow-hidden bg-white">
        <div class="flex align-items-center gap-2 px-3 py-2 border-bottom-1 surface-border">
          <p-iconfield iconPosition="left" class="w-full md:w-20rem">
            <p-inputicon [styleClass]="esperandoBusqueda() ? 'pi pi-spinner pi-spin' : 'pi pi-search'" />
            <input
              pInputText
              type="text"
              class="w-full p-inputtext-sm"
              placeholder="Buscar por nombre o apellido"
              [ngModel]="busqueda()"
              (ngModelChange)="onSearchInput($event)"
              [attr.aria-busy]="esperandoBusqueda()"
              autocomplete="off"
              aria-label="Buscar en el muelle"
            />
          </p-iconfield>
          @if (busqueda()) {
            <p-button
              type="button"
              label="Limpiar"
              [text]="true"
              size="small"
              (onClick)="limpiarBusqueda()"
            />
          }
        </div>

        <app-person-table
          [rows]="rows()"
          [columns]="columnas"
          [loading]="loading()"
          [paginator]="totalRecords() > pageSize"
          [rowsPerPage]="pageSize"
          [lazy]="true"
          [totalRecords]="totalRecords()"
          [first]="first()"
          [yoId]="yoId()"
          [modo]="'muelle'"
          [actorEsLider]="userStore.isLider()"
          [emptyMessage]="vacio()"
          (pageChange)="onTablePageChange($event)"
          (menuAction)="onMenu($event)"
        />
      </div>
    } @else if (loading() || !contextoListo()) {
      <app-skeleton-block variant="table" [rows]="8" />
    }
  </app-content-card>
</section>

<p-dialog
  [visible]="motivoVisible()"
  (visibleChange)="onMotivoVisibleChange($event)"
  [modal]="true"
  [draggable]="false"
  [closable]="!enviando()"
  [dismissableMask]="!enviando()"
  [style]="{ width: '30rem' }"
  [header]="'Eliminar a ' + (personaEliminar()?.nombreCompleto || 'esta persona')"
>
  <p class="m-0 mb-3 text-sm text-color-secondary">
    Describe la razón para eliminar a {{ personaEliminar()?.nombreCompleto || 'esta persona' }}.
  </p>

  <textarea
    pTextarea
    class="w-full"
    rows="3"
    [ngModel]="motivoTexto()"
    (ngModelChange)="motivoTexto.set($event)"
    aria-label="Motivo de la eliminación"
  ></textarea>

  <div class="flex justify-content-end gap-2 pt-3">
    <p-button
      type="button"
      label="Cancelar"
      severity="secondary"
      [outlined]="true"
      [disabled]="enviando()"
      (onClick)="cerrarMotivo()"
    />
    <p-button
      type="button"
      label="Solicitar eliminación"
      icon="pi pi-check"
      [disabled]="motivoInvalido() || enviando()"
      [loading]="enviando()"
      (onClick)="confirmarEliminar()"
    />
  </div>
</p-dialog>
